export const FAVORITES_SET = 'FAVORITES_SET';
export const FAVORITE_ADD = 'FAVORITE_ADD';
export const FAVORITE_DELETE = 'FAVORITE_DELETE';



